import type React from 'react';

import { EditDepartmentInfoButton } from '@vlabs/monokit/features/';

import { DepartmentGeneralInfo } from '@vlabs/monokit/entities/departments';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import st from './DepartmentGeneralInfo.module.sass';
import { useDepartmentGeneralInfoTranslation } from './i18n';

interface DepartmentGeneralInfoProps {
  departmentId: DepartmentId;
}

function DepartmentGeneralInfoWidget({
  departmentId,
}: DepartmentGeneralInfoProps): React.JSX.Element {
  const { t } = useDepartmentGeneralInfoTranslation();

  return (
    <div className={st.Root}>
      <div className={st.TitleWrapper}>
        <div className={st.Title}>{t('title')}</div>
        <EditDepartmentInfoButton departmentId={departmentId} />
      </div>
      <DepartmentGeneralInfo departmentId={departmentId} />
    </div>
  );
}

export { DepartmentGeneralInfoWidget as DepartmentGeneralInfo };
